/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_DescriptionInputs */

const et_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aitame teenusettevõtetel ja agentuuridel saada kliente prognoositavalt. Kõrge konversiooniga veebilehed koos SEO ja automatiseerimisega. Keskmiselt 3,4x käibekasv. Asume Tallinnas, Eestis.`)
};

const en_meta_description = /** @type {(inputs: Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We help service businesses and agencies get clients predictably. High-converting websites with SEO and automation. On average 3.4x revenue growth. Based in Tallinn, Estonia.`)
};

/**
* | output |
* | --- |
* | "We help service businesses and agencies get clients predictably. High-converting websites with SEO and automation. On average 3.4x revenue growth. Based in T..." |
*
* @param {Meta_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const meta_description = /** @type {((inputs?: Meta_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_meta_description(inputs)
	return en_meta_description(inputs)
});